import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import VehicleExperience from '../pages/VehicleExperience';

const BACKEND = (typeof window !== 'undefined' ? window.location.origin : '');

/**
 * Guard for the public /vehicle/:cardId route.
 *
 * The Automotive Used Vehicle experience must render ONLY when the physical
 * card's interaction_mode === "automotive_used_vehicle" (the source of truth).
 * If someone opens /vehicle/{cardId} for a card that is Review Shield / Hotel /
 * Standard / etc., we resolve the card's current interaction_mode and hand off
 * to /api/tap, which redirects it to the correct experience — instead of
 * showing the Automotive "vehicle not available" screen.
 *
 * VehicleExperience itself, the vehicle resolver, and all Automotive
 * functionality are left completely untouched.
 */
export default function VehicleRouteGuard() {
    const { cardId } = useParams();
    const [decision, setDecision] = useState('loading'); // 'loading' | 'automotive'

    useEffect(() => {
        let active = true;
        const tapUrl = `${BACKEND}/api/tap?card=${encodeURIComponent(cardId)}`;
        fetch(`${BACKEND}/api/public/card-route/${encodeURIComponent(cardId)}`)
            .then((r) => (r.ok ? r.json() : { is_automotive: false }))
            .then((d) => {
                if (!active) return;
                if (d && d.is_automotive) {
                    setDecision('automotive');
                } else {
                    // Non-automotive card → resolve to its real experience.
                    window.location.replace(tapUrl);
                }
            })
            .catch(() => {
                if (active) window.location.replace(tapUrl);
            });
        return () => { active = false; };
    }, [cardId]);

    if (decision === 'automotive') return <VehicleExperience />;

    return (
        <div
            data-testid="vehicle-route-guard-loading"
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#0b0f19',
                color: '#94a3b8',
                fontFamily: 'system-ui, sans-serif',
                fontSize: '0.95rem',
            }}
        >
            Loading…
        </div>
    );
}
